<template>
  <div class="schoolQuestion">
    <div class="header" ref="header">
      <el-row v-show="!isOpen" :gutter="10" type="flex">
        <!-- <el-col :span="5">
          <span class="title star"><span style="color: red">*</span>统计日期:</span>
          <el-date-picker
            v-model="searchForm.computeDate"
            type="date"
            :clearable="false"
            :editable="false"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @change="computeDateChange"
          >
          </el-date-picker>
        </el-col> -->
        <el-col :span="8">
          <span class="title">题库创建日期:</span>
          <el-date-picker
            v-model="creatTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="creatTimeChange"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="11">
          <span class="title">省市区:</span>
          <el-cascader
            :options="options.localeList"
            :props="{ multiple: true }"
            collapse-tags
            clearable
            v-model="cityValue"
            @change="cityChange"
          ></el-cascader>
        </el-col>
        <el-col :span="5"
          ><div class="btn">
            <el-button size="small" @click="reset">重置</el-button>
            <el-button type="primary" size="small" @click="search">查询</el-button>
            <el-button type="text" @click="open">展开<i class="el-icon-arrow-down el-icon--right"></i></el-button></div
        ></el-col>
      </el-row>
      <div class="openTrue" v-show="isOpen">
        <el-row :gutter="10" type="flex">
          <!-- <el-col :span="5">
            <span class="title star"><span style="color: red">*</span>统计日期:</span>
            <el-date-picker
              v-model="searchForm.computeDate"
              type="date"
              :clearable="false"
              :editable="false"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @change="computeDateChange"
            >
            </el-date-picker>
          </el-col> -->
          <el-col :span="8">
            <span class="title">题库创建日期:</span>
            <el-date-picker
              v-model="creatTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="creatTimeChange"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="6">
            <span class="title">省市区:</span>
            <el-cascader
              :options="options.localeList"
              :props="{ multiple: true }"
              collapse-tags
              clearable
              v-model="cityValue"
              @change="cityChange"
            ></el-cascader>
          </el-col>
          <el-col :span="5">
            <span class="title">学校: </span>
            <el-select
              v-model="searchForm.schoolIDs"
              multiple
              collapse-tags
              filterable
              remote
              reserve-keyword
              :remote-method="remoteMethodSchool"
              :loading="loading"
              placeholder="请输入学校名称"
              class="tags-select-input"
              @change="(val) => changeSelect(val, 'schoolIDs', 'schoolList')"
              @remove-tag="(val) => selectRemoveTag(val, 'schoolIDs')"
            >
              <el-option
                v-for="item in options.schoolList"
                :key="item.schoolID"
                :label="item.schoolName"
                :value="item.schoolID"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="10" type="flex">
          <el-col :span="5">
            <span class="title">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="opacity: 0">*</span>年级:</span>
            <el-select
              v-model="searchForm.gradeIDs"
              multiple
              collapse-tags
              placeholder="请选择年级"
              @change="(val) => changeSelect(val, 'gradeIDs', 'gradeList')"
              @remove-tag="(val) => selectRemoveTag(val, 'gradeIDs')"
            >
              <el-option
                v-for="item in options.gradeList"
                :key="item.gradeID"
                :label="item.gradeName"
                :value="item.gradeID"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <span class="title"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;学科:</span
            >
            <el-select
              v-model="searchForm.subjectIDs"
              multiple
              collapse-tags
              filterable
              placeholder="请选择学科"
              @change="(val) => changeSelect(val, 'subjectIDs', 'subjectList')"
              @remove-tag="(val) => selectRemoveTag(val, 'subjectIDs')"
            >
              <el-option
                v-for="item in options.subjectList"
                :key="item.subjectID"
                :label="item.subjectName"
                :value="item.subjectID"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="7" class="colMedia">
            <span class="title">题库名称:</span>
            <el-select
              v-model="searchForm.exercisePoolIDs"
              multiple
              collapse-tags
              filterable
              remote
              reserve-keyword
              :remote-method="remoteMethodPool"
              :loading="loading"
              class="tags-select-input isWidth"
              placeholder="请输入题库名称"
              @change="(val) => changeSelect(val, 'exercisePoolIDs', 'exercisepoolList')"
              @remove-tag="(val) => selectRemoveTag(val, 'exercisePoolIDs')"
            >
              <el-option
                v-for="item in options.exercisepoolList"
                :key="item.exercisePoolID"
                :label="item.exercisePoolName"
                :value="item.exercisePoolID"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="7">
            <span class="title media">练习册名称:</span>
            <el-select
              v-model="searchForm.exercisePoolIDs"
              multiple
              filterable
              collapse-tags
              remote
              reserve-keyword
              :remote-method="remoteMethodAlias"
              :loading="loading"
              class="tags-select-input isWidth"
              placeholder="请输入练习册名称"
              @change="(val) => changeSelect(val, 'exercisePoolIDs', 'exercisepoolList')"
              @remove-tag="(val) => selectRemoveTag(val, 'exercisePoolIDs')"
            >
              <el-option
                v-for="item in options.exercisepoolList"
                :key="item.exercisePoolID"
                :label="item.exercisePoolAliasName"
                :value="item.exercisePoolID"
              >
                <span>{{ item.exercisePoolAliasName }}</span>
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <div class="btn">
          <el-button size="small" @click="reset">重置</el-button>
          <el-button type="primary" size="small" @click="search">查询</el-button>
          <el-button type="text" @click="close">收起<i class="el-icon-arrow-up el-icon--right"></i></el-button>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="hint">
        <div class="left">
          学校题库分析
          <el-popover
            placement="bottom-start"
            width="400"
            trigger="hover"
            :visible-arrow="false"
            popper-class="popper-hint"
          >
            <div v-html="QYTKFX"></div>
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </div>
        <div class="right">
          <el-button type="primary" size="small" @click.native="downExcel" :loading="downLoading"> 导出数据</el-button>
        </div>
      </div>
      <div class="table">
        <el-table
          :data="tableData"
          :key="'schoolQuestion' + keytable"
          ref="table"
          border
          size="small"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
          height="100%"
          @sort-change="sortChange"
          :default-sort="{ prop: 'createTime', order: 'descending' }"
          v-loading="loading"
        >
          <el-table-column fixed type="index" label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ (searchForm.pageNum - 1) * searchForm.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cityName" label="市" fixed min-width="110"> </el-table-column>
          <el-table-column prop="localeName" label="区" fixed min-width="110"> </el-table-column>
          <el-table-column prop="schoolName" label="学校" fixed min-width="110"> </el-table-column>
          <el-table-column prop="subjectName" label="学科" min-width="110"> </el-table-column>
          <el-table-column prop="gradeName" label="年级" min-width="110"></el-table-column>
          <el-table-column prop="exercisepoolID" label="题库ID" min-width="110"></el-table-column>
          <el-table-column prop="exercisepoolName" label="题库名称" min-width="110"></el-table-column>
          <el-table-column prop="exercisepoolAliasName" label="练习册名称" min-width="110"></el-table-column>
          <el-table-column prop="createTime" label="题库创建时间" min-width="140" sortable="custom"></el-table-column>
          <el-table-column
            prop="entryexercise_num"
            label="录入题数"
            min-width="110"
            sortable="custom"
          ></el-table-column>
          <el-table-column prop="exercise_num" label="使用题数" min-width="110" sortable="custom"></el-table-column>
          <el-table-column prop="exercise_nums" label="使用题次" min-width="110" sortable="custom"></el-table-column>
          <el-table-column
            prop="usenums_everyexercise"
            label="每题平均使用次数"
            min-width="150"
            sortable="custom"
          ></el-table-column>
          <el-table-column prop="user_num" label="使用教师数" min-width="110" sortable="custom"></el-table-column>
          <el-table-column
            prop="useexercisenum_everyone"
            label="教师人均使用题数"
            min-width="150"
            sortable="custom"
          ></el-table-column>
          <el-table-column prop="hte_nums" label="组卷数" min-width="110" sortable="custom"></el-table-column>
        </el-table>
      </div>
      <div class="pagSize">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :page-size="searchForm.pageSize"
          :current-page.sync="searchForm.pageNum"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { QYTKFX } from '@/utils/explainText.js'
import { resize } from '@/mixins/resize.js'
import dayjs from 'dayjs'
import filterSelect from '../../components/FilterSelect/index.vue'
import { schoolUseDownload } from '@/api/modules/excelApi.js'
import { generateTableParms, getToken, excelName } from '@/utils/index.js'
import fileSave from '@/utils/fileSave.js'
export default {
  name: 'SchoolQuestion',
  mixins: [resize],
  components: {
    filterSelect
  },
  data() {
    return {
      QYTKFX: QYTKFX,
      schoolList: JSON.parse(sessionStorage.getItem('schoolList')),
      searchForm: {
        computeDate: dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
        startDate: '',
        endDate: '',
        pageSize: 12,
        pageNum: 1,
        gradeIDs: [],
        subjectIDs: [],
        localeIDs: [],
        exercisePoolIDs: [],
        schoolIDs: [],
        ascOrDes: false,
        sortCode: 'createTime'
      },
      cityValue: null,
      addressOptions: [],
      gradeOptions: [],
      subjectOptions: [],
      idOptions: [],
      questionNameOptions: [],
      workBookOptions: [],
      isOpen: false,
      tableData: [],
      loading: false,
      total: 0,
      keytable: 0,
      options: {
        localeList: [],
        schoolList: [],
        gradeList: [],
        subjectList: [],
        exercisepoolList: []
      },
      creatTime: ['2022-01-01', dayjs().format('YYYY-MM-DD')],
      searchList: ['startDate', 'localeIDs', 'schoolIDs', 'gradeIDs', 'subjectIDs', 'exercisePoolIDs'],
      optionList: ['startDate', 'localeList', 'schoolList', 'gradeList', 'subjectList', 'exercisepoolList'],
      searchListI: undefined,
      downLoading: false
    }
  },
  created() {
    this.searchForm.startDate = this.creatTime[0]
    this.searchForm.endDate = this.creatTime[1]
    this.localeOptions(1)
    this.getTableList()
  },
  methods: {
    open() {
      this.$refs.header.style.height = '210px'
      this.isOpen = true
    },
    close() {
      this.$refs.header.style.height = '85px'
      this.isOpen = false
    },
    computeDateChange() {
      // this.localeOptions();
    },
    // 创建时间
    creatTimeChange(v) {
      if (v === null) {
        this.searchForm.startDate = ''
        this.searchForm.endDate = ''
      } else {
        this.searchForm.startDate = v[0]
        this.searchForm.endDate = v[1]
      }
      this.localeOptions('startDate')
    },
    schoolChecked(v) {
      this.searchForm.schoolIDs = []
      this.searchForm.schoolIDs = v.map((el) => el.value)
    },
    // selectAll
    selectAll(arg1, arg2) {
      let str = arg1.substr(0, arg1.length - 1)
      if (this.searchForm[arg1].length < this.options[arg2].length) {
        this.searchForm[arg1] = []
        this.options[arg2].map((item) => {
          this.searchForm[arg1].push(item[str])
        })
        this.searchForm[arg1].unshift('全选')
      } else {
        this.searchForm[arg1] = []
      }
      if (arg1 != 'exercisePoolIDs') {
        this.localeOptions(arg1)
      }
    },
    changeSelect(val, arg1, arg2) {
      if (arg1 != 'exercisePoolIDs') {
        this.localeOptions(arg1)
      }
    },
    selectRemoveTag(val, arg1) {
      this.localeOptions(arg1)
    },
    cityChange(v) {
      this.searchForm.localeIDs = v.map((el) => el[2])
      this.localeOptions('localeIDs')
    },
    // 远程搜索
    remoteMethodSchool(v) {
      v = v.trim()
      if (v) {
        this.getSchoolList(v)
      }
    },
    remoteMethodPool(v) {
      v = v.trim()
      if (v) {
        this.getExercisepoolList('exercisePoolName', v)
      }
    },
    remoteMethodAlias(v) {
      v = v.trim()
      if (v) {
        this.getExercisepoolList('exercisePoolAliasName', v)
      }
    },
    reset() {
      this.searchForm = this.$options.data().searchForm
      this.cityValue = this.$options.data().cityValue
      this.creatTime = ['2022-01-01', dayjs().format('YYYY-MM-DD')]
      this.searchForm.startDate = this.creatTime[0]
      this.searchForm.endDate = this.creatTime[1]
      this.localeOptions(1)
      this.getTableList()
      this.keytable++
    },
    search() {
      this.searchForm.pageNum = 1
      this.getTableList()
    },
    // 导出数据
    downExcel() {
      this.downLoading = true

      const obj = {
        ...this.searchForm,
        ...getToken()
      }

      delete obj.pageNum
      delete obj.pageSize

      const url = schoolUseDownload + generateTableParms(obj)

      obj.fileName = excelName('学校题库使用分析', obj.computeDate, obj.computeDate) + '.xlsx'

      fileSave(url, obj.fileName).then(() => {
        this.downLoading = false
      })
    },
    // 分页器事件
    handleCurrentChange(v) {
      this.searchForm.pageNum = v
      this.getTableList()
    },
    // 排序
    sortChange({ prop, order }) {
      this.searchForm.sortCode = prop
      if (order !== null) {
        order == 'descending' ? (this.searchForm.ascOrDes = false) : (this.searchForm.ascOrDes = true)
        this.getTableList()
      }
    },
    getSchoolList(v) {
      let obj = {
        computeDate: this.searchForm.computeDate,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        localeIDs: this.searchForm.localeIDs,
        schoolName: v
      }
      this.$API.questionDataApi
        .getSchoolListFuzzyQuery(obj)
        .then((res) => {
          this.options.schoolList = res.result
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getExercisepoolList(name, v) {
      let obj = {
        computeDate: this.searchForm.computeDate,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        localeIDs: this.searchForm.localeIDs,
        schoolIDs: this.searchForm.schoolIDs,
        gradeIDs: this.searchForm.gradeIDs,
        subjectIDs: this.searchForm.subjectIDs,
        [name]: v
      }
      this.$API.questionDataApi
        .getSchoolExercisePoolListFuzzyQuery(obj)
        .then((res) => {
          this.options.exercisepoolList = res.result
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 根据前置条件筛选后置条件列表
    // 传入字段的change事件,根据字段把字段后的筛选框的值清空
    localeOptions(searchName = '') {
      this.searchListI = undefined
      if (searchName != 1) {
        searchName != ''
          ? (this.searchListI = this.searchList.findIndex((el) => el == searchName))
          : (this.searchListI = 0)
        for (let idx = this.searchListI + 1; idx < this.searchList.length; idx++) {
          this.searchForm[this.searchList[idx]] = []
        }
      }
      this.$API.questionDataApi
        .getSchoolOptions(this.searchForm)
        .then((res) => {
          // 前端处理 只把当前change事件的选择框后边的数据进行重新赋值
          if (searchName != 1) {
            for (let idx = this.searchListI + 1; idx < this.optionList.length; idx++) {
              if (this.optionList[idx] != 'schoolList' && this.optionList[idx] != 'exercisepoolList') {
                this.options[this.optionList[idx]] = res.result[this.optionList[idx]]
              } else {
                this.options[this.optionList[idx]] = []
              }
            }
          } else {
            ;['subjectList', 'schoolList', 'localeList', 'gradeList', 'exercisepoolList'].forEach((el) => {
              if (el != 'schoolList' && el != 'exercisepoolList') {
                this.options[el] = res.result[el]
              } else {
                this.options[el] = []
              }
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取表格数据
    getTableList() {
      this.loading = true
      this.$API.questionDataApi
        .getSchoolUseList(this.searchForm)
        .then((res) => {
          this.tableData = res.result
          if (res.result.length > 0) {
            this.total = this.tableData[0].total
          } else {
            this.total = 0
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.schoolQuestion {
  @include myMain();
  .header {
    transition: height 0.5s;
    height: 85px;
    background-color: #ffffff;
    padding: 0 20px;
    font-size: 14px;
    border-radius: 2px;
    flex-shrink: 0;
    overflow: hidden;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    .el-row {
      padding-top: 20px;
      padding-bottom: 20px;
      .colMedia {
        justify-content: center;
      }
      .el-col {
        display: flex;
        align-items: center;
        .title {
          margin: 0 5px 0 0px;
          white-space: nowrap;
        }
        @media screen and (max-width: 1670px) {
          .media {
            margin-left: 2em;
          }
        }
        @media screen and (min-width: 1670px) {
          .media {
            margin-left: 4em;
          }
        }
        .isWidth {
          width: 260px;
        }
        .tags-select-input {
          height: 40px;
          /deep/ .el-select__tags {
            height: 40px;
            white-space: nowrap;
            overflow: hidden;
            flex-wrap: nowrap;
          }
          /deep/ .el-select__tags-text {
            display: inline-block;
            max-width: 85px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          /deep/ .el-tag__close.el-icon-close {
            right: -4px;
          }
        }
      }

      &:nth-child(2) {
        padding-bottom: 20px;
        padding-top: 10px;
      }
    }
    .btn {
      width: 100%;
      text-align: end;
    }
    ::v-deep .el-date-editor .el-range-separator {
      width: 8%;
    }
  }
  .content {
    @include myContent();
    .hint {
      @include myContent-hint();
    }
    .table {
      @include myTable();
    }
    .pagSize {
      @include myPagSize();
    }
  }
}
</style>
